import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_nsti_stock_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    guid_company: fromDatatype.GuidDataFieldInterface;
    guid_location: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    serial_no: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    glcode_guid: fromDatatype.GuidDataFieldInterface;
    sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
    qty_base: fromDatatype.NumericDatatypeInterface;
    warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
    ccy: fromDatatype.VarcharDatatypeInterface;
    guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
    purchase_date: fromDatatype.TimestampTzDatatypeInterface;
    purchase_gendoc_hdr_doc_type: fromDatatype.VarcharDatatypeInterface;
    purchase_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    purchase_gendoc_line_doc_type: fromDatatype.VarcharDatatypeInterface;
    purchase_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_location_guid: fromDatatype.GuidDataFieldInterface;
    purchase_branch_guid: fromDatatype.GuidDataFieldInterface;
    sales_date: fromDatatype.TimestampTzDatatypeInterface;
    sales_gendoc_hdr_doctype: fromDatatype.VarcharDatatypeInterface;
    sales_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_gendoc_line_doctype: fromDatatype.VarcharDatatypeInterface;
    sales_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
    sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    sales_location_guid: fromDatatype.GuidDataFieldInterface;
    sales_branch_guid: fromDatatype.GuidDataFieldInterface;
    current_location_guid: fromDatatype.GuidDataFieldInterface;
    current_branch_guid: fromDatatype.GuidDataFieldInterface;
    current_value_incl_tax: fromDatatype.NumericDatatypeInterface;
    current_value_excl_tax: fromDatatype.NumericDatatypeInterface;
    current_for_sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
    current_for_sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    pic_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_nsti_stock_hdr_RowClass implements bl_fi_nsti_stock_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    guid_company: fromDatatype.GuidDataFieldInterface;
    guid_location: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    serial_no: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    glcode_guid: fromDatatype.GuidDataFieldInterface;
    sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
    qty_base: fromDatatype.NumericDatatypeInterface;
    warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
    ccy: fromDatatype.VarcharDatatypeInterface;
    guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
    purchase_date: fromDatatype.TimestampTzDatatypeInterface;
    purchase_gendoc_hdr_doc_type: fromDatatype.VarcharDatatypeInterface;
    purchase_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    purchase_gendoc_line_doc_type: fromDatatype.VarcharDatatypeInterface;
    purchase_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
    purchase_location_guid: fromDatatype.GuidDataFieldInterface;
    purchase_branch_guid: fromDatatype.GuidDataFieldInterface;
    sales_date: fromDatatype.TimestampTzDatatypeInterface;
    sales_gendoc_hdr_doctype: fromDatatype.VarcharDatatypeInterface;
    sales_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_gendoc_line_doctype: fromDatatype.VarcharDatatypeInterface;
    sales_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
    sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    sales_location_guid: fromDatatype.GuidDataFieldInterface;
    sales_branch_guid: fromDatatype.GuidDataFieldInterface;
    current_location_guid: fromDatatype.GuidDataFieldInterface;
    current_branch_guid: fromDatatype.GuidDataFieldInterface;
    current_value_incl_tax: fromDatatype.NumericDatatypeInterface;
    current_value_excl_tax: fromDatatype.NumericDatatypeInterface;
    current_for_sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
    current_for_sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    pic_name: fromDatatype.VarcharDatatypeInterface;
}
